import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess2061Status: 'idle',
    startProcess2061Error: undefined as any,
    loadUserParamsProcess2061Status: 'idle',
    loadUserParamsProcess2061Error: undefined as any,
    stammIni_EnableSprachenStatus: 'idle',
    stammIni_EnableSprachenError: undefined as any,

    process2061List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    stammIni_EnableSprachen: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess2061 = createAsyncThunk('process2061Slice/startProcess2061', async ({ process2061 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess2061/`,
        prepareData(process2061),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess2061Status } = getState().process2061Slice
        return startProcess2061Status !== 'pending'
    }
})

export const loadUserParamsProcess2061 = createAsyncThunk('process2061Slice/loadUserParamsProcess2061', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess2061/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess2061Status } = getState().process2061Slice
        return loadUserParamsProcess2061Status !== 'pending'
    }
})

export const stammIni_EnableSprachen = createAsyncThunk('process2061Slice/stammIni_EnableSprachen', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/StammIni_EnableSprachen/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { stammIni_EnableSprachenStatus } = getState().process2061Slice
        return stammIni_EnableSprachenStatus !== 'pending'
    }
})

const Process2061Slice = createSlice({
    name: 'process2061Slice',
    initialState,
    reducers: {
        resetstartProcess2061: (state) => {
            state.job = undefined
            state.startProcess2061Error = undefined
        },
        resetstartProcess2061Error: (state) => {
            state.startProcess2061Error = undefined
        },
        resetloadUserParamsProcess2061: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess2061Error = undefined
        },
        resetloadUserParamsProcess2061Error: (state) => {
            state.loadUserParamsProcess2061Error = undefined
        },
        resetstammIni_EnableSprachen: (state) => {
            state.stammIni_EnableSprachen = undefined
            state.stammIni_EnableSprachenError = undefined
        },
        resetstammIni_EnableSprachenError: (state) => {
            state.stammIni_EnableSprachenError = undefined
        },
        removeFromProcess2061ListById: (state, action) => {
            state.process2061List = state.process2061List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess2061ListByIds: (state, action) => {
            state.process2061List = state.process2061List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process2061List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess2061Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process2061List = []
            state.startProcess2061Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess2061.pending, (state) => {
            state.startProcess2061Status = 'pending'
            state.startProcess2061Error = undefined
        })
        builder.addCase(startProcess2061.fulfilled, (state, action) => {
            state.startProcess2061Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess2061.rejected, (state, action) => {
            state.startProcess2061Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess2061Error = action.error.message
            } else {
                state.startProcess2061Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess2061.pending, (state) => {
            state.loadUserParamsProcess2061Status = 'pending'
            state.loadUserParamsProcess2061Error = undefined
        })
        builder.addCase(loadUserParamsProcess2061.fulfilled, (state, action) => {
            state.loadUserParamsProcess2061Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess2061.rejected, (state, action) => {
            state.loadUserParamsProcess2061Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess2061Error = action.error.message
            } else {
                state.loadUserParamsProcess2061Error = action.payload
            }
        })

        builder.addCase(stammIni_EnableSprachen.pending, (state) => {
            state.stammIni_EnableSprachenStatus = 'pending'
            state.stammIni_EnableSprachenError = undefined
        })
        builder.addCase(stammIni_EnableSprachen.fulfilled, (state, action) => {
            state.stammIni_EnableSprachenStatus = 'idle'

            {
                state.stammIni_EnableSprachen = action.payload

            }
        })
        builder.addCase(stammIni_EnableSprachen.rejected, (state, action) => {
            state.stammIni_EnableSprachenStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.stammIni_EnableSprachenError = action.error.message
            } else {
                state.stammIni_EnableSprachenError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess2061,
    resetstartProcess2061Error,
    resetloadUserParamsProcess2061,
    resetloadUserParamsProcess2061Error,
    resetstammIni_EnableSprachen,
    resetstammIni_EnableSprachenError,
    removeFromProcess2061ListById,
    removeFromProcess2061ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process2061Slice.actions
export default Process2061Slice.reducer
